import { ActionTypes } from '../types/actionTypes';

const setSizeSidebar = (payload: boolean): any => ({
  type: ActionTypes.SET_SIZE_SIDEBAR,
  payload,
});

export default setSizeSidebar;
